const PropTypes = require('prop-types');
//@vendor
const React = require('react');
// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestCostWafer = require('components/mortgageRequest/mortgageRequestCostWafer/mortgageRequestCostWafer');

const MortgageRequestAppraisalRequestCostWafer = props => {
    const { immPayment, text, className, isClientWithoutAccounts } = props;
    const amount = `${MortgageRequestCurrencyHelp({currency: immPayment.get('appraisalCost')})}`;

    return (
        <MortgageRequestCostWafer
            title="mortgageRequestAppraisalRequestCostWafer-infoTitle"
            text={isClientWithoutAccounts ? "mortgageRequestAppraisalRequestCostWafer-infoTextNoClient" : text}
            amount={amount}
            label="mortgageRequestAppraisalRequestCostWafer-taxLabel"
            className={className}
        />
    );
};

MortgageRequestAppraisalRequestCostWafer.propTypes = {
    immPayment: PropTypes.object.isRequired,
    text: PropTypes.string,
    className: PropTypes.string,
    isClientWithoutAccounts: PropTypes.bool
};

MortgageRequestAppraisalRequestCostWafer.defaultProps = {
    text: 'mortgageRequestAppraisalRequestCostWafer-infoText',
};

module.exports = MortgageRequestAppraisalRequestCostWafer;
